import { CheckSquare } from 'lucide-react'
import React from 'react'
import styled from 'styled-components'

const ToggleButton = styled.button`
  position: absolute;
  bottom: 4rem;
  right: 1rem;
  width: 3rem;
  height: 3rem;
  background: transparent;
  border: none;
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.2s ease;
  z-index: 500;
  pointer-events: auto;

  &:hover {
    color: rgba(255, 255, 255, 0.8);
    transform: scale(1.1);
  }

  &:active {
    transform: scale(0.9);
  }

  svg {
    width: 1.5rem;
    height: 1.5rem;
    filter: drop-shadow(0 1px 2px rgba(0, 0, 0, 0.8));
  }
`

export const DataValidationToggleButton: React.FC<{
  onClick: () => void
}> = ({ onClick }) => {
  return (
    <ToggleButton onClick={onClick} title='Toggle Data Validation'>
      <CheckSquare />
    </ToggleButton>
  )
}
